import ElementsWrapper from 'components/app/elements_wrapper';
import Give from 'components/views/giving/give';
import GiveScheduled from 'components/views/giving/give-scheduled';
import { useQueryParams } from 'hooks/useQueryParams';
import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { DEFAULT_LOCALE } from 'utils/constants';

export default function Page() {
  const { subscription_id: subscriptionId } = useQueryParams();
  return (
    <ElementsWrapper>{subscriptionId ? <GiveScheduled subscriptionId={subscriptionId} /> : <Give />}</ElementsWrapper>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? DEFAULT_LOCALE)),
    },
  };
};
